import React, { useCallback } from 'react';

import { beVerifyStripeIdentityToggle } from 'actions/salon/beVerifyStripeIdentity.action';
import Button from 'components/form/Button.component';
import { usePrepareWriteOnly } from 'hooks/usePrepare.hook';
import { useSalonNeedsReload } from 'providers/Pusher.provider';
import { useCurrentSalonId, useIsSalonRestrictedToCriticalServices } from 'providers/SalonBasicInfo.provider';
import { fromAnyToPrettyJson } from 'utils/converters/json.util';
import { locationReload } from 'utils/dom/location.util';
import { concatTag as ct } from 'utils/strings/manipulate.util';

const StripePage = (props) => {
  const salonId = useCurrentSalonId();
  const isRestrictedToCriticalServices = useIsSalonRestrictedToCriticalServices();
  const isPageInNeedOfReload = useSalonNeedsReload();

  const { up: toggleStripeIdentityVerificationStatus } = usePrepareWriteOnly(beVerifyStripeIdentityToggle);

  const handleReload = useCallback(() => void locationReload({ tag: ct('StripePage', 'handleReload()') }), []);

  return (
    <div data-bem="StripePage" style={{ background: 'gray', width: '100vw', height: '100vh' }}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '1em' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button tag="StripePage__toggle" onClick={toggleStripeIdentityVerificationStatus} xSpace>
            Toggle Restriction Status
          </Button>
          <Button tag="PageReloadWatcher__reload" onClick={handleReload} xSpace>
            Reload
          </Button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <pre style={{ background: '#ccc', display: 'inline-block', padding: '1em' }}>
            {fromAnyToPrettyJson({
              salonId,
              isRestrictedToCriticalServices,
              isPageInNeedOfReload,
            })}
          </pre>
        </div>
        <div>
          <pre style={{ background: '#ccc', padding: '1em' }}>{fromAnyToPrettyJson(props)}</pre>
        </div>
      </div>
    </div>
  );
};

export default StripePage;
